import Vue from 'vue'
import Vuex from 'vuex'
import {
  getItem,
  setItem
} from '@/untils/storage.js'
import user from '@/store/user'
import getters from '@/store/getters'
import permission from '@/store/permission'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    orderMsg:{}
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    permission
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js